import ModelGroup from './ModelGroup'
import Model from './Model'
import SpecificModelReason from './SpecificModelReason'
import EquipmentGraphics from './EquipmentGraphics'
import SecurityLevel from './SecurityLevel'
import CardReader from './CardReader'
export class VendorInfo {
    RequestID: number;
    RemoveReasonID?: number;
    InstallReasonID?: number;
    ModelGroupID: number;
    ModelGroup: ModelGroup;
    ModelID: number;
    Model: Model;
    SpecificModelReasonID: number;
    SpecificModelReason: SpecificModelReason;
    EquipmentGraphicsID: number;
    EquipmentGraphics: EquipmentGraphics;
    SecurityLevelID: number;
    SecurityLevel: SecurityLevel;
    SecurityCage: boolean;
    CardReaderID: number;
    CardReader: CardReader;
    SpecificModelNeeded: boolean;
    EquipmentLocation: string;
    NumberOfVendors: number;
    DefaultModel: string;
    MaterialNumber: string;
    CONAModelGroup: string;
    SetOnSite: boolean;
    Casters: boolean;
    LevelSellDown: boolean;
    ProjectedVolume?: number;
    EquipmentLocations?: string;
}

export default VendorInfo;